import React from 'react';
import AppUserRole from './components';
import Layout from '../../layouts/index';

const UserRole = () => {
    return (
        <Layout>
            <AppUserRole />
        </Layout>
    );
};

export default UserRole;
